import React from "react"
import { Message } from "../../models"
import styled from '~/ui/styled'
import { ImageMessage } from "./image-message"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import MessageTime from "./message-time"
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import { Flex } from "~components/El"
import { CHAT_IMAGE_GROUP_GAP, CHAT_IMAGE_MAX_WIDTH } from "~utils/media-fit"

const Container = styled.div<{ $byMe: boolean }>`
  width: fit-content;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $byMe }) => ($byMe ? "flex-end" : "flex-start")};
  gap: ${CHAT_IMAGE_GROUP_GAP}px;
`

const TimeWrap = styled(Flex)<{ byMe: boolean }>`
  width: 100%;
  justify-content: ${({ byMe }) => (byMe ? "flex-end" : "flex-start")};
`

interface ImagesMessageProps {
  message: Message
  setPopupOptionListModal?: ({ visible, message }: { visible: boolean; message: Message }) => void
}

// 优化使用纯组件
export const ImagesMessage: React.FC<ImagesMessageProps> = observer(
  ({ message, setPopupOptionListModal }) => {
    const imgs = message?.attach?.imgs ?? []

    return (
      <Container $byMe={message.byMe}>
        {imgs.map((img: any) => {
          return (
            <ImageMessage
              key={`${message.message_id}-${img.uri || img.url}`}
              setPopupOptionListModal={setPopupOptionListModal}
              message={message}
              showTime={false}
              maxDisplayWidth={CHAT_IMAGE_MAX_WIDTH}
              messageHack={{
                attach_path: img.uri,
                url: img.url,
                progress: img.progress,
                isUploading: img.isUploading,
              }}
            />
          )
        })}
        <TimeWrap byMe={message.byMe}>
          <MessageTime time={message.created} />
        </TimeWrap>
      </Container>
    )
  },
)
export const WrappedImagesMessage: React.FC<MessageProps & ImagesMessageProps> = (props) => {
  return props.message.byMe ? (
    <MessageSent {...props} Component={ImagesMessage} isNoBg={true} />
  ) : (
    <MessageReceived {...props} Component={ImagesMessage} isNoBg={true}/>
  )
}
export default WrappedImagesMessage
